import { createStart, createCsrfMiddleware, createMiddleware } from "@tanstack/react-start";

import { renderErrorPage } from "./lib/error-page";
import { safeErrorDescription } from "./lib/security/safe-error";
import { securityHeaders } from "./lib/security/headers";
// No Supabase Auth bearer attacher: Auth0 is the only identity provider in this
// project. The Auth0 access token middleware is added in the Auth0 step.

const errorMiddleware = createMiddleware().server(async ({ next }) => {
  try {
    return await next();
  } catch (error) {
    if (error != null && typeof error === "object" && "statusCode" in error) {
      throw error;
    }
    console.error(safeErrorDescription(error));
    return new Response(renderErrorPage(), {
      status: 500,
      headers: { "content-type": "text/html; charset=utf-8" },
    });
  }
});

// Start installs this automatically when src/start.ts is absent; defining the
// file opts out, so re-add it explicitly to keep server functions protected
// from cross-site requests.
const csrfMiddleware = createCsrfMiddleware({
  filter: (ctx) => ctx.handlerType === "serverFn",
});

const responseProtection = createMiddleware().server(async ({ next }) => {
  const { setResponseHeader, getRequestUrl } = await import("@tanstack/react-start/server");
  for (const [name, value] of Object.entries(securityHeaders(getRequestUrl().pathname))) setResponseHeader(name, value);
  // Final Cache-Control is decided in src/server.ts (cacheControlFor); default stays private.
  setResponseHeader("Cache-Control", "private, no-store");
  return next();
});

export const startInstance = createStart(() => ({
  functionMiddleware: [],
  requestMiddleware: [responseProtection, errorMiddleware, csrfMiddleware],
}));
